import { render, staticRenderFns } from "./ArchiveConsignmentReturn.vue?vue&type=template&id=03672d10&"
import script from "./ArchiveConsignmentReturn.vue?vue&type=script&lang=js&"
export * from "./ArchiveConsignmentReturn.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveConsignmentReturn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveConsignmentReturn.vue"
export default component.exports